import { SET_CONNECTION, LOGOUT, CLEAR_INTERNAL_SERVER_ERROR, CLEAR_500_ERROR } from './AuthConstants'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setConnection = (value) => {
  const action = {
    type: SET_CONNECTION,
    payload: value,
  }
  return action
}
/**
 * Commit a session replacement: THIS tab has a validated replacement token in hand.
 *
 * Tagged `session-replaced` and listed in `CROSS_TAB_LOGOUT_REASONS` because its only
 * caller — `AuthValidate` — pairs it with a `LOGIN_SUCCESS` that IS broadcast (only
 * `LOGIN`/`LOGIN_ERROR` are blacklisted). Untagged, the pair split: the other tabs took
 * the new provider's access token while keeping the previous provider's profile,
 * waiting-room queue and chart state, since the LOGOUT that resets those reducers never
 * arrived. Both halves have to travel together for "every tab shares one identity" to
 * hold.
 *
 * MUST be dispatched immediately before that `LOGIN_SUCCESS`, never speculatively ahead of
 * the request that produces the replacement token. Dispatched early it is a promise the
 * caller cannot keep: every failure exit (bad/expired link, non-OK response, unparseable
 * body, fetch timeout) leaves the broadcast LOGOUT standing with no compensating login, and
 * a sibling tab holding a live video visit is torn down by a link that never validated.
 * Use `clearSessionLocally` for the pre-flight clear.
 */
export const logout = () => {
  const action = {
    type: LOGOUT,
    reason: 'session-replaced',
    payload: {},
  }
  return action
}

/**
 * Drop this tab's session while a replacement is being validated.
 *
 * Same reducer effect as `logout`, but the reason is deliberately absent from
 * `CROSS_TAB_LOGOUT_REASONS`, so it stays local. `AuthValidate` needs the local clear up
 * front — it must not render the outgoing provider's profile, queue or charts while the
 * new token is in flight — but that clear is speculative until the refresh call returns,
 * and speculation must not cross tabs. See `logout` above for what goes wrong when it does.
 */
export const clearSessionLocally = () => {
  const action = {
    type: LOGOUT,
    reason: 'session-replace-pending',
    payload: {},
  }
  return action
}
export const clearInternalError = () => {
  const action = {
    type: CLEAR_INTERNAL_SERVER_ERROR,
  }
  return action
}
export const clear500Error = () => {
  const action = {
    type: CLEAR_500_ERROR,
  }
  return action
}
